export default function getEnv(name) {
    if (window?.envConfigs?.[name] && window?.envConfigs?.[name] !== "${properties.idaasTenantConsoleUrl}") {
      return window?.envConfigs?.[name]
    } else {
      return process.env[name]
    }
  }
  